import PropTypes from 'prop-types';

export default function AppThemeShell({ children }) {
  return (
    <div
      className="opengrit-app-theme-shell"
      data-og-theme-shell="true"
    >
      {children}
    </div>
  );
}

AppThemeShell.propTypes = {
  children: PropTypes.node,
};

AppThemeShell.defaultProps = {
  children: null,
};
